module.exports = __webpack_public_path__ + "img/Convertible.e4d339a2.jpg";